import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import {
  IComando,
  IFilter,
  IListado,
  ILuminaria,
  IQueryParam,
} from 'modelos/src';
import { LuminariasService } from '../../service';
import { firstValueFrom, Subscription } from 'rxjs';
import { HelperService } from 'src/app/auxiliares/helper.service';
import { SeleccionPotenciaModalComponent } from './seleccion-potencial-modal/seleccion-potencia-modal.component';
import { DialogService } from 'src/app/auxiliares/dialog/dialog.service';
import { ListadosService } from 'src/app/auxiliares/listados.service';

@Component({
  selector: 'app-detalles-modal',
  templateUrl: './detalles-modal.component.html',
  styleUrls: ['./detalles-modal.component.scss'],
})
export class DetallesModalComponent implements OnInit {
  public luminaria: ILuminaria = {};

  public comandos?: IListado<IComando>;
  public ultimoComando?: IComando;
  public comandos$?: Subscription;

  public mapTypeId: google.maps.MapTypeId = google.maps.MapTypeId.ROADMAP;
  public mapTypeControl: boolean = false;
  public ubicacionLuminaria: { lat: number; lng: number } = {
    lat: 0,
    lng: 0,
  };
  public tieneUbicacionReal: boolean = false;
  showSpinner = true;
  public loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public luminariasService: LuminariasService,
    private listadosService: ListadosService,
    private dialogRef: MatDialogRef<DetallesModalComponent>,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private dialogService: DialogService,
    public helper: HelperService,
  ) {
    if (data) {
      this.luminaria = data.luminaria;
      this.createUbicacionLuminaria();
    }
  }

  public graficoLDR(): any {
    const options = {
      // opciones del chart
    };
    return options;
  }

  public graficoUso(): any {
    const options = {
      // opciones chat encendidos y uso
    };
    return options;
  }

  public cerrar(): void {
    this.dialogRef.close();
  }

  public encenderLuminaria(): void {
    const dialogRef = this.dialog.open(SeleccionPotenciaModalComponent, {
      data: {
        actual: this.luminariasService.getReporteNormalizado(
          this.luminaria?.ultimoReporte?.reporte,
        )?.dimmingValue,
        modo: 'encender',
      },
      width: '450px',
    });

    dialogRef.afterClosed().subscribe(async (result: number | undefined) => {
      if (result !== undefined && this.luminaria.deveui) {
        this.loading = true;
        try {
          await firstValueFrom(
            this.luminariasService.encender(
              this.luminaria.deveui,
              result,
              this.luminaria,
            ),
          );
          this.helper.notifSuccess('Comando enviado');
        } catch (error) {
          console.error(error);
          this.helper.notifError(error);
        }
        this.loading = false;
      }
    });
  }

  public cambiarDimmer(): void {
    const dialogRef = this.dialog.open(SeleccionPotenciaModalComponent, {
      data: {
        actual: this.luminariasService.getReporteNormalizado(
          this.luminaria.dispositivo?.ultimoReporte?.reporte,
        )?.dimmingValue,
        modo: 'dimmer',
      },
      width: '450px',
    });

    dialogRef.afterClosed().subscribe(async (result: number | undefined) => {
      if (result !== undefined && this.luminaria.deveui) {
        this.loading = true;
        try {
          await firstValueFrom(
            this.luminariasService.dimerizar(
              this.luminaria.deveui,
              result,
              this.luminaria,
            ),
          );
          this.helper.notifSuccess('Comando enviado');
        } catch (error) {
          console.error(error);
          this.helper.notifError(error);
        }
        this.loading = false;
      }
    });
  }

  public async apagarLuminaria(): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirme la acción',
      `¿Deseas Apagar la Luminaria ${this.luminaria.identificacion || this.luminaria.deveui}?`,
    );
    if (confirm) {
      if (this.luminaria.deveui) {
        this.loading = true;
        try {
          await firstValueFrom(
            this.luminariasService.apagar(
              this.luminaria.deveui,
              this.luminaria,
            ),
          );
          this.helper.notifSuccess('Comando enviado');
        } catch (error) {
          console.error(error);
          this.helper.notifError(error);
        }
        this.loading = false;
      }
    }
  }

  private createUbicacionLuminaria(): void {
    if (
      !this.data?.luminaria?.ubicacion &&
      !this.data?.luminaria?.dispositivo?.ubicacion
    ) {
      this.tieneUbicacionReal = false;
      this.ubicacionLuminaria = {
        lat: -34.603722,
        lng: -58.381592,
      };
      return;
    }

    this.tieneUbicacionReal = true;
    this.ubicacionLuminaria = {
      lat:
        this.data.luminaria?.ubicacion?.lat ||
        this.data.luminaria?.dispositivo?.ubicacion?.lat ||
        -34.603722,
      lng:
        this.data.luminaria?.ubicacion?.lng ||
        this.data.luminaria?.dispositivo?.ubicacion?.lng ||
        -58.381592,
    };
  }

  initializeTabs(): void {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = event.currentTarget as HTMLElement;
        const tabId = target.getAttribute('onclick')?.split("'")[1];

        tabButtons.forEach((btn) => btn.classList.remove('active'));
        tabContents.forEach((content) => content.classList.remove('active'));

        target.classList.add('active');
        if (tabId) {
          document.getElementById(tabId)?.classList.add('active');
        }
      });
    });
  }

  // listar comandos de la luminaria
  private async listarComandosLuminaria(): Promise<void> {
    if (this.luminaria) {
      const queryParams: IQueryParam = {
        page: 0,
        limit: 5,
        sort: '-fechaCreacion',
      };

      const filter: IFilter = { deveui: this.luminaria.deveui };
      queryParams.filter = JSON.stringify(filter);
      //
      this.comandos$?.unsubscribe();
      this.comandos$ = this.listadosService
        .subscribe<IListado<IComando>>('comandos', queryParams)
        .subscribe((data) => {
          this.comandos = data;
          this.ultimoComando = data.datos[0];
        });
      await this.listadosService.getLastValue('comandos', queryParams);
    }
  }

  get iconoMapa(): string {
    const icono = this.luminariasService.determinarEstadoLuminaria(
      this.luminaria,
    ).iconoMapa;
    return icono || '';
  }

  get direccionLuminaria(): string {
    const config = this.luminaria?.dispositivo?.config;
    const configNormalizada =
      this.luminariasService.getConfigNormalizada(config);
    return configNormalizada.direccion || '-';
  }

  async ngOnInit(): Promise<void> {
    this.initializeTabs();
    await this.listarComandosLuminaria();
    // Highcharts.chart('ldrs', this.graficoLDR(luminaria.ldrs));
    // Highcharts.chart('uso', this.graficoUso(luminaria.encendidos));
    this.showSpinner = false;
    this.cdr.detectChanges();
  }
}
